(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
let searchYotpoBadge;
let searchYotpoOriginalParent;
const mountSearchYotpoBadge = () => {
  const slot = document.querySelector('.hdt-main-search .hdt-search-yotpo-slot');
  searchYotpoBadge = searchYotpoBadge || document.getElementById('y-badges');
  if (!searchYotpoBadge) return;
  searchYotpoOriginalParent = searchYotpoOriginalParent || searchYotpoBadge.parentElement;
  if (slot && window.matchMedia('(min-width: 1150px)').matches) {
    if (searchYotpoBadge.parentElement !== slot) slot.appendChild(searchYotpoBadge);
  } else if (searchYotpoOriginalParent && searchYotpoBadge.parentElement !== searchYotpoOriginalParent) {
    searchYotpoOriginalParent.appendChild(searchYotpoBadge);
  }
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountSearchYotpoBadge, { once: true });
} else {
  mountSearchYotpoBadge();
}
window.addEventListener('load', mountSearchYotpoBadge, { once: true });
window.addEventListener('resize', mountSearchYotpoBadge);
new MutationObserver(mountSearchYotpoBadge).observe(document.documentElement, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-account-links"]) return;
  try {
    
(() => {
  const locale = document.documentElement.lang.split('-')[0];
  const prefix = ['en','ar','ru','fr'].includes(locale) ? '/' + locale : '';
  const direction = ['he','ar'].includes(locale) ? 'rtl' : 'ltr';
  const fix = root => {
    root.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      const path = url.pathname.replace(/^\/(en|ar|ru|fr)(?=\/)/, '');
      const login = path === '/customer_authentication/login' || path === '/account/login';
      const register = path === '/account/register';
      if (!login && !register) return;
      const target = prefix + (register ? '/account/register' : '/account/login') + '?return_url=' + encodeURIComponent(prefix + '/pages/rewards');
      if (link.getAttribute('href') !== target) link.setAttribute('href', target);
    });
  };
  let shadow;
  const connect = () => {
    const host = document.querySelector('#casa-landing-page #shadow-host');
    if (!host || !host.shadowRoot || shadow === host.shadowRoot) return;
    shadow = host.shadowRoot;
    const style = document.createElement('style');
    style.textContent = ':host, #shadow-container, #app-container, #app-container h1, #app-container h2, #app-container h3, #app-container p, #app-container a, #app-container button, #app-container input, #app-container div { direction:' + direction + '!important; }';
    shadow.appendChild(style);
    fix(shadow);
    new MutationObserver(() => fix(shadow)).observe(shadow, {childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    shadow.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || !/^\/(?:en\/|ar\/|ru\/|fr\/)?account\/(login|register)\?return_url=/.test(link.getAttribute('href'))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(link.href);
    }, true);
  };
  new MutationObserver(connect).observe(document.documentElement, {childList:true,subtree:true});
  connect();
  let attempts = 0;
  const timer = setInterval(() => { connect(); if (shadow || ++attempts > 60) clearInterval(timer); }, 500);
})();

  } catch(e) { console.error(e); }
})();
})();
